module.exports = __webpack_public_path__ + "img/vote-3.9fd91059.png";